import { Shark, Utils } from "shark-mvc";
import moment from "moment";

import NousCoreModel from "./NousCoreModel";
import OrganizationMembership from "./OrganizationMembership";

class Task extends NousCoreModel {
	static STATUS_CLOSED = 7;
	static STATUS_ON_HOLD = 2;
	static STATUS_RUNNING = 1;

	static VALUATION_AMOUNT_PER_CUSTOMER = 2;
	static VALUATION_AMOUNT_PER_USER = 1;
	static VALUATION_FIXED_DURATION = 4;
	static VALUATION_FIXED_VALUE = 3;

	closed = false;
	// closedAt = "0000-00-00 00:00:00";
	description = "";
	endDate = "0000-00-00 00:00:00";
	extraData = {
		wrikeSyncList: [],
	};
	fixedDuration = 0;
	fixedValue = 0;
	lastActivityAt = "0000-00-00 00:00:00";
	name = "";
	ownerGuid = "";
	projectGuid = "";
	startDate = "0000-00-00 00:00:00";
	userLastActivityAt = "0000-00-00 00:00:00";
	userLastActivityAtGuid = "";
	userList = [];
	valuationType = 0;

	__clientName = "";
	__currUserIsProjectOwner = false;
	__cssClasses = new Set();
	__cssClassesString = "";
	__currUserCanChangePermission = false;
	__currUserCanEdit = false;
	__currUserIsOwner = false;
	__hasFixedDuration = false;
	__hasFixedValue = false;
	__isRunningWorkSessionTask = false;
	__oraganizationGuid = "";
	__ownerInitials = "";
	__ownerName = "";
	__ownerPictureURL = "";
	__projectName = "";
	__selected = false;
	__statusIcon = "";
	__statusLabel = "";
	__userLastActivityAt = "0000-00-00 00:00:00";
	__valuationTypeLabel = "";
	__visible = true;

	__isWrikeTask = false;
	__hasWrikeSyncData = false;

	constructor(data) {
		super(data, "Task");

		this.status = 1;
		
		if (data) {
			this.import(data);
		}
	}

	export () {
		const exportData = super.export();

		// exportData.closed = this.exportBooleanField("closed");

		exportData.endDate = this.exportDateField("endDate");
		exportData.startDate = this.exportDateField("startDate");
		// exportData.tags = this.exportArrayField("tags");
		exportData.extraData = this.exportObjectField("extraData");

		exportData.userList = this.exportArrayField("userList");
				
		return exportData;
	}

	flattenCSSClasses () {
		this.__cssClassesString = `status-${this.status}`;
		this.__cssClasses.forEach(item => this.__cssClassesString += " " + item);
	}

	getDuration (client) {
		const durationMS = this.workSessionList.reduce((a, b) => {
			return a + b.__duration;
		}, 0);
		
		this.__internalCost = this.workSessionList.reduce((a, b) => {
			return a + b.__userInternalCost;
		}, 0);
		
		this.__externalCost = this.workSessionList.reduce((a, b) => {
			return a + b.__userExternalCost;
		}, 0);

		//this.durationMS = this.endDate.diff(this.startDate);
		const duration = moment.duration(durationMS);
		this.__durationLabel = duration.format("HH:mm:ss", { trim: false });

		//this.__durationLabel = moment(duration).utc().format("HH:mm:ss");
		this.__internalCostLabel = Shark.$store.moneyFormatter.format(this.__internalCost);
		this.__externalCostLabel = Shark.$store.moneyFormatter.format(this.__externalCost);

		const multipliedDuration = this.workSessionList.reduce((a, b) => {
			return a + b.__multipliedDuration;
		}, 0);
		const multipliedExternalCost = this.workSessionList.reduce((a, b) => {
			return a + b.__userMultipliedExternalCost;
		}, 0);
		this.__multipliedDuration = multipliedDuration;
		// this.__multipliedDurationLabel = moment.duration(multipliedDuration).format("HH:mm:ss", { trim: false });
		this.__multipliedExternalCost = multipliedExternalCost;
		this.__multipliedExternalCostLabel = Shark.$store.moneyFormatter.format(this.__multipliedExternalCost);

		let durationPrefix = "";

		if (this.__hasFixedDuration) {
			this.__invoiceValue = (client.fixedHourlyValue * this.fixedDuration);
			durationPrefix = "[T]";
		}
		else if (this.__hasFixedValue) {
			this.__invoiceValue = this.fixedValue;
			durationPrefix = "[€]";
		}
		else {
			this.__invoiceValue = this.workSessionList.reduce((a, b) => {
				return a + b.__invoiceValue;
			}, 0);
		}
		this.__invoiceValueLabel = durationPrefix + Shark.$store.moneyFormatter.format(this.__invoiceValue);

		return durationMS;
	}

	import (data, options) {
		super.import(data, options);

		// this.importBooleanField("closed", data.closed);
		// this.importDateField("closedAt", data.closedAt);
		this.importNumberField("fixedDuration", data.fixedDuration);
		this.importNumberField("fixedValue", data.fixedValue);
		this.importNumberField("valuationType", data.valuationType);

		// this.__hasFixedDuration = this.fixedDuration > 0;
		// this.__hasFixedValue = this.fixedValue > 0;

		this.__isWrikeTask = this.name.slice(0, 2).toLowerCase() === "w#";
		this.__hasWrikeSyncData = this.extraData.wrikeSyncList.length > 0;

		if (Shark.$store.projectList) {
			const project = Utils.safp(Shark.$store.projectList, "guid", this.projectGuid);
			this.__projectName = project?.name;
			this.__oraganizationGuid = project?.organizationGuid;
		}
		
		this.parseDates(data);
		this.parseOwner();
		this.parseProject();
		this.parseStatus();
		this.parseUserTaskPermissions();
		this.parseValuationType();

		this.flattenCSSClasses();
	}

	onProjectGuidChanged () {
		this.parseProject();
	}

	onStatusChanged () {
		this.parseStatus();
	}

	// on__statusLabelChanged () {
	// 	this.parseStatus();
	// }

	onUserLastActivityAtChanged () {
		// Duplicato!!
		if (this.importDateField("userLastActivityAt", this.userLastActivityAt)) {
			this.__userLastActivityAt = this.userLastActivityAt.format("YYYY-MM-DD HH:mm:ss");
			this.__userLastActivityAtLabel = this.userLastActivityAt.format("DD/MM/YYYY - HH:mm");
		}
	}

	onValuationTypeChanged () {
		this.parseValuationType();
	}

	parseDates (data) {
		if (this.importDateField("lastActivityAt", data.lastActivityAt)) {
			this.__lastActivityAt = this.lastActivityAt.format("YYYY-MM-DD HH:mm:ss");
			this.__lastActivityAtLabel = this.lastActivityAt.format("DD/MM/YYYY - HH:mm");
		}

		if (this.importDateField("startedAt", data.startedAt)) {
			this.__startedAt = this.startedAt.format("YYYY-MM-DD HH:mm:ss");
			this.__startedAtLabel = this.startedAt.format("DD/MM/YYYY - HH:mm");
		}

		// Duplicato!!
		if (this.importDateField("userLastActivityAt", data.userLastActivityAt)) {
			this.__userLastActivityAt = this.userLastActivityAt.format("YYYY-MM-DD HH:mm:ss");
			this.__userLastActivityAtLabel = this.userLastActivityAt.format("DD/MM/YYYY - HH:mm");
		}
	}

	parseProject () {
		const { projectList } = Shark.get();

		if (projectList) {
			const project = Utils.safp(projectList, "guid", this.projectGuid);

			if (project) {
				const { currUser } = Shark.get();
				this.__clientName = project.clientName;
				this.__currUserIsProjectOwner = project.ownerGuid === currUser.guid;
				this.__projectName = project.name;
			}
		}
		// else {
		// 	console.warn("NON HO I PROGETTI!");
		// }
	}

	parseOwner () {
		const owner = Utils.safp(Shark.$store.allUserList, "guid", this.ownerGuid);

		if (owner) {
			this.__ownerInitials = owner.__initials;
			// Dave. questo probabilmente dovrebbe essere il nome dell'Utente nell'organizzazione.
			this.__ownerName = owner.__fullName;
			this.__ownerPictureURL = owner.pictureURL;
		}

		this.__currUserIsOwner = this.ownerGuid === Shark.$store.currUser.guid;
		this.__currUserCanChangePermission = this.ownerGuid === Shark.$store.currUser.guid;
		this.__currUserCanEdit = this.ownerGuid === Shark.$store.currUser.guid;
	}

	parseStatus () {
		// let statusLabel = "";
		const statusObj = Shark.$store.taskStatusMap.find(item => item.id === this.status);
		// switch (this.status) {
		// 	case Task.STATUS_CLOSED:
		// 		statusLabel = "Chiuso";
		// 		break;
		// 	case Task.STATUS_RUNNING:
		// 		statusLabel = "In corso";
		// 		break;
		// }

		if (statusObj) {
			this.set({
				closed: this.status === Task.STATUS_CLOSED,
				__statusIcon: statusObj.icon,
				__statusLabel: statusObj.label,
			});
			
			// this.__statusLabel = this.status === 1 ? "In corso" : "Chiuso";
			this.clean(["closed", "__statusIcon", "__statusLabel"]);

			// Dave: Questo render è "bruttino", perché lo devo chiedere io, ma risolve anche il cambio dell'icona... Andrebbe reso default di Shark..
			// Dave (e Alice): Questo render non va bene, rallenta tutto, Alice, parliamone!
			// Shark.render();
		}
	}

	parseUserTaskPermissions () {
		if (Shark.$store.organizationMembershipList) {
			const taskOrganizationMembership = Shark.$store.organizationMembershipList.find(item => item.organizationGuid === this.__oraganizationGuid);
			
			// console.log("taskOrg" + taskOrganizationMembership);
			if (taskOrganizationMembership) {
				this.__currUserCanChangePermission = taskOrganizationMembership.role === OrganizationMembership.ROLE_POWER_USER && Shark.$store.currUser.guid == this.ownerGuid ? true : [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				
				this.__currUserCanEditTask = Shark.$store.currUser.guid == this.ownerGuid ? true : [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				this.__currUserCanEditTaskGenericField = taskOrganizationMembership.role === OrganizationMembership.ROLE_POWER_USER && Shark.$store.currUser.guid == this.ownerGuid ? true : [OrganizationMembership.ROLE_ADMIN, OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				this.__currUserCanEditTaskCustomerField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				this.__currUserCanEditTaskOrganizationField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				this.__currUserCanEditTaskEconomicField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
				
				this.__currUserCanDeleteTask = [OrganizationMembership.ROLE_OWNER].includes(taskOrganizationMembership.role);
				
				this.__currUserCanSeeTaskEconomicField = [OrganizationMembership.ROLE_OWNER, OrganizationMembership.ROLE_POWER_ADMIN].includes(taskOrganizationMembership.role);
			}
			else // starter /
			{
				this.__currUserCanChangePermission = false;
				this.__currUserCanEditTask = true;
				this.__currUserCanEditTaskGenericField = true;
				this.__currUserCanEditTaskCustomerField = false;
				this.__currUserCanEditTaskOrganizationField = false;
				this.__currUserCanEditTaskEconomicField = false;

				this.__currUserCanDeleteTask = true;
				this.__currUserCanSeeTaskEconomicField = false;
			}
		}
	}

	parseValuationType() {
		switch (this.valuationType) {
			case Task.VALUATION_AMOUNT_PER_CUSTOMER:
				this.__valuationTypeLabel = "Importo orario del Cliente";

				if (Shark.$store.projectList && this.projectGuid) {
					const project = Utils.safp(Shark.$store.projectList, "guid", this.projectGuid);

					if (project) {
						const customer = Utils.safp(Shark.$store.clientList, "guid", project.clientGuid);

						if (customer) {
							this.__customerHourlyCost = customer.fixedHourlyValue;
						}
					}
				}
				break;
			case Task.VALUATION_AMOUNT_PER_USER:
				this.__valuationTypeLabel = "Importo orario per Utente";
				break;
			case Task.VALUATION_FIXED_DURATION:
				this.__valuationTypeLabel = "Durata fissa (H)";
				break;
			case Task.VALUATION_FIXED_VALUE:
				this.__valuationTypeLabel = "Importo fisso (€)";
				break;
		}

		this.__hasFixedDuration = this.valuationType === Task.VALUATION_FIXED_DURATION;
		this.__hasFixedValue = this.valuationType === Task.VALUATION_FIXED_VALUE;
		this.__useCustomerFixedAmount = this.valuationType === Task.VALUATION_AMOUNT_PER_CUSTOMER;

		// this.__hasFixedDuration = this.fixedDuration > 0;
		// this.__hasFixedValue = this.fixedValue > 0;
	
		if (this.__hasFixedDuration) {
			this.__fixedDurationDisplay = `<div class="badge bg-info">H</div>`;
		}
		if (this.__hasFixedValue) {
			this.__fixedValueDisplay = `<div class="badge bg-info">€</div>`;
		}
	}

	validate () {
		let errors = [];

		errors = errors.concat(this.validatNameGuid());
		errors = errors.concat(this.validateValuationTypeGuid());

		return errors;
	}

	validatNameGuid () {
		let error = [];

		if (this.name.trim() === "") {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_task_name,
				field: "name",
			});
		}
		return error;
	}

	validateValuationTypeGuid () {
		let error = [];

		if (this.__currUserCanEditTaskEconomicField && (this.valuationType === 0 || this.valuationType === undefined)) {
			error.push({
				error: Shark.$store.labels.errors.you_must_insert_valuation_type,
				field: "valuationType",
			});
		}
		return error;
	}
}

Shark.registerModel("Task", Task);

export default Task;